// Flag REACT_APP_LIST_PERF_ENABLED (PR C, DESIGN-CLARITY §7.2): shared by
// the /logo and /design rows so neither screen imports the other's row
// component. Rows 0-3 load eagerly (above the fold on a 100 px row), the
// rest get loading="lazy"; the thumbnail keeps a 110x74 box so the row
// never shifts while the image arrives. The box is an aspect hint: the
// row wrappers cap it with max-w-full so a narrow image column (admin:
// weight 1 = 1/12 of the row) never overflows into its neighbours.
export const LIST_PERF_EAGER_ROWS = 4;
export const LIST_PERF_IMAGE_BOX = { w: 110, h: 74 } as const;
